export default function content() {
    return `
    _linkedin_partner_id = '2382276';
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    window._linkedin_data_partner_ids.push(_linkedin_partner_id);
    `;
}
